import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { SELECT_PLAN_SECTION_ID } from '@/constants';
import { useStripeV2Plans } from '@/hooks/useStripeV2Plans';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { SectionPaymentMethodSelection } from '@/pages/Paywall/sections/PaymentMethodSelection';

import { PaymentOnPageDescription } from './components/Description';
import { PaymentSafeness } from './components/Safeness';
import { PaymentOnPageSubscriptions } from './components/Subscriptions';
import { PaywallPaymentOnPageStyles } from './PaymentOnPage.styles';

export const PaywallSectionPaymentOnPage: React.FC<{
  withSafeness?: boolean;
  theme?: 'dark-violet' | 'domination' | null;
}> = ({ withSafeness, theme }) => {
  const { isLoadingPlans, stripePlans, monthlyPlan, selectedPlan, isSuccess } =
    useStripeV2Plans();

  return (
    <PaywallPaymentOnPageStyles id={SELECT_PLAN_SECTION_ID}>
      {theme === 'domination' ? (
        <OnboardingTitle className=" subscriptions-title">
          Your{' '}
          <UiTypography variant="inherit" color="red-gradient" component="span">
            Custom Super Dialogue
          </UiTypography>{' '}
          Plan is ready!
        </OnboardingTitle>
      ) : (
        <OnboardingTitle className=" subscriptions-title">
          Choose{' '}
          <UiTypography variant="inherit" color="gradient" component="span">
            your
          </UiTypography>{' '}
          plan
        </OnboardingTitle>
      )}

      <PaymentOnPageSubscriptions
        isLoadingConfig={isLoadingPlans}
        isCreatingSubscription={false}
        isSuccess={isSuccess}
        stripePlans={stripePlans}
        theme={theme}
      />

      <SectionPaymentMethodSelection />

      <PaymentOnPageDescription plan={selectedPlan} monthlyPlan={monthlyPlan} />

      {withSafeness && <PaymentSafeness />}
    </PaywallPaymentOnPageStyles>
  );
};
